module.exports = __webpack_public_path__ + "img/MondoMenu-logo.2902d437.png";